import { FormField } from './field';
import { OptionDTO } from './option';

declare let _: any;

export class SelectField extends FormField {
    options: OptionDTO[] = [];
    viewValue: OptionDTO[] = [];
    isMultiple: boolean;
    searchSelect: boolean;
    componentGroupId: number;
    codescVar: string;
    compSolrQuery: string;
    fieldValuesBehavior: string;
    fieldValues: any[];
	withImages: boolean;
	optionsJs:string;
	autoSingleSelect:boolean;

    constructor(options: {} = {}) {
        super(options);
        this.options = options['options'] || [];
		this.dynamicOptions = this.type === 'Yes/No' ? false : true;
        this.isMultiple = options['isMultiple']  || false;
        this.searchSelect = options['searchSelect']  || false;
        this.componentGroupId = <number>options['componentGroupId'] || 0;
        this.codescVar = options['codescVar'] != 0 ? options['codescVar'] : '';
        this.compSolrQuery = options['compSolrQuery'] ? '&' + options['compSolrQuery'] : '';
        this.fieldValuesBehavior = options['fieldValuesBehavior'] || 'include';
        this.fieldValues = options['fieldValues'] || [];
        this.withImages = options['withImages'] || false;
        this.optionsJs = options['optionsJs'] || null;
        this.autoSingleSelect = options['autoSingleSelect'] || false;
    }

	setValue(value, force = false) {
		if (value || force ||  value === '') {
			this.value = this.isMultiple && value ? value.split('|') : value;
		}
		if(this.fieldValues.length) {
			this.fieldValues = _.uniq(this.fieldValues.concat(this.value));
		}
	}

    getOptions(value): OptionDTO | OptionDTO[] {
        return Array.isArray(value) ?
            this.options.filter(v => value.includes(v['key'] || v['value'])) :
            this.options.find(v => value == v['key'] || value == v['value']);
    }
    getTitle(value) {
        const options =   this.getOptions(value);
        return Array.isArray(options) ?
            options.map(v => v.value) :
            options?.value;
    }

    getKey(value) {
        const options =   this.getOptions(value);
        return Array.isArray(options) ?
            options.map(v => v.key) :
            options?.key;
    }
}


